module.exports = __webpack_public_path__ + "img/cmf.5b6accce.png";